import { createRouter, createWebHashHistory } from "vue-router";
import { routes } from "../App/index";
// import { useAuthStore } from "@/stores/auth";
import beforeEach from "@/router/beforeEach";
// import routes from "@/App";

const router = createRouter({
    history: createWebHashHistory(), // or createWebHashHistory()
    scrollBehavior(to, from, savedPosition) {},
    routes: routes,
});

router.beforeEach(beforeEach);

export default router;
